export default __webpack_public_path__ + "static/media/org_code.621bf23f.svg";